// @flow
import * as React from 'react';
import { View, Text } from 'react-native';
import { ThemeContext } from 'react-native-elements';


export type Props = {
    children: React.Node,
    helpText: string,
}


const FieldWrapper = (props: Props): React.Node => {
    const { helpText, children } = props;

    const { theme } = React.useContext(ThemeContext);

    return (
        <View>
            {children}
            {helpText && (
                <Text style={theme.FieldHelpText}>
                    {helpText}
                </Text>
            )}
        </View>
    );
};
export default FieldWrapper;
